import { useRef } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import Routers from './routes';
import '@xinosolutions/xs-shell/styles.css';
import './assets/css/style.css';
import './assets/css/light-theme.css';
import './assets/css/dashboard-overrides.css';
import './assets/css/sidebar.css';
import './assets/css/portal-landing.css';
import './assets/css/utilities.css';

import { SnackbarProvider } from 'notistack';
import { ThemeProvider } from './contexts/ThemeContext';
import ErrorBoundaryFallback from './components/ErrorBoundaryFallback';
import AdminProviders from './components/providers/AdminProviders';

function App() {
  const notistackRef = useRef(null);

  const onClickDismiss = (key) => () => {
    notistackRef.current?.closeSnackbar(key);
  };

  return (
    <div className="App">
      <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
        <ThemeProvider defaultTheme="dark">
          <SnackbarProvider
            ref={notistackRef}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            maxSnack={3}
            action={(key) => (
              <button
                type="button"
                className="xs-btn-close xs-btn-close-white mx-2"
                onClick={onClickDismiss(key)}
                aria-label="Close"
              />
            )}
          >
            <AdminProviders>
              <Routers />
            </AdminProviders>
          </SnackbarProvider>
        </ThemeProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
